var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCompatiable)?_c('apple-pay-button',{staticStyle:{"width":"242px"},attrs:{"buttonstyle":"black","type":"plain","locale":"en"},on:{"click":_vm.onApplePayButtonClicked}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }